import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "updated-plus",
  "use": "updated-plus-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"updated-plus\"><g data-name=\"icon - plus sign - 12px\" fill=\"none\"><path d=\"M0 0h12v12H0z\" /><g data-name=\"↳color\" stroke=\"#031425\" stroke-linecap=\"round\" stroke-width=\"1.25\"><path data-name=\"Line 152\" d=\"M6 2v8\" /><path data-name=\"Line 153\" d=\"M2 6h8\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol